<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState()"
  [content]="progressiveFormCardContent()"
  [asyncSubmission]="true"
  [trackingConfig]="{
    toolName: rendering().componentName,
    step: stepNumber(),
    stepName: 'controleren',
  }"
>
  <ng-template #content>
    <!-- Confirmation summary and EDR notice -->
    <div class="mb-2">
      <span
        *wlGenericRichText="orderContent().confirmationSummaryBefore"
      ></span>
      @if (orderContent().confirmationSummaryTooltip) {
        <wl-tooltip
          class="pe-1"
          [tooltip]="{
            description: orderContent().confirmationSummaryTooltip,
          }"
        ></wl-tooltip>
      }
      <span *wlGenericRichText="orderContent().confirmationSummaryAfter"></span>
    </div>

    <!-- Telemarketing consents (phone opt-in) -->
    <div class="d-flex flex-column gap-2 mb-2">
      <span class="fw-bold">{{
        orderContent().telemarketingConsentsTitle
      }}</span>
      <wl-checkbox
        stepName="controleren"
        fieldName="telemarketing contract advies"
        [rendering]="rendering()"
        [step]="stepNumber()"
        [formsControl]="formState().controls.energyAdvicePhoneAccepted"
        [tooltip]="orderContent().telemarketingSustainabilityTooltip"
      >
        <span>
          {{ orderContent().telemarketingContractAdvice }}
        </span>
      </wl-checkbox>

      <wl-checkbox
        stepName="controleren"
        fieldName="telemarketing verduurzaming"
        [rendering]="rendering()"
        [step]="stepNumber()"
        [formsControl]="formState().controls.sustainabilityAdvicePhoneAccepted"
        [tooltip]="orderContent().telemarketingSustainabilityTooltip"
      >
        <span>
          {{ orderContent().telemarketingSustainability }}
        </span>
      </wl-checkbox>
    </div>

    <!-- EDM marketing consents (email opt-out) -->
    <div class="mb-2">
      <span *wlGenericRichText="orderContent().consentsTextBefore"></span>
      <button
        (click)="openConsentsModal($event)"
        class="btn btn-link p-0 align-baseline"
      >
        {{ orderContent().consentsTextLink }}
      </button>
      <span *wlGenericRichText="orderContent().consentsTextAfter"></span>
    </div>

    <!-- EDM consents info card -->
    @if (
      emailConsentValues().energyAdvice || emailConsentValues().sustainability
    ) {
      <div class="consents-card mb-2">
        <wl-info-card
          [title]="{ value: orderContent().consentsMessageTitle }"
          [message]="{ value: emailConsentMessage() }"
          [hijackButton]="true"
          [buttonText]="orderContent().consentsMessageButton"
          [buttonType]="'button-outline'"
          [backgroundGrey]="envConfig.brand === 'ed'"
          [shadow]="envConfig.brand === 'essent'"
          (buttonClick)="openConsentsModal()"
        ></wl-info-card>
      </div>
    }

    <!-- Terms and conditions card -->
    <div class="terms-and-conditions-v2-container p-2 mb-2 rounded">
      <p class="fw-bold">
        {{ orderContent().termsAndConditionsFormGroupLabel }}
      </p>
      <ng-template [ngTemplateOutlet]="termsAndConditionsCard"></ng-template>
    </div>

    <!-- ATO consent card -->

    @if (orderContent().enableAtoCheck) {
      <div class="terms-and-conditions-v2-container p-2 rounded">
        <p class="fw-bold">
          {{ orderContent().atoConsentFormGroupLabel }}
        </p>
        <ng-template [ngTemplateOutlet]="atoConsentCard"></ng-template>
      </div>
    }
  </ng-template>

  <ng-template #footnote>
    <div
      class="mt-2"
      *wlGenericRichText="{
        value: orderContent().confirmationLabelAfterSubmitButton,
      }"
    ></div>
  </ng-template>
</wl-simple-progressive-form-card>

<ng-template #termsAndConditionsCard>
  <wl-checkbox
    [rendering]="rendering()"
    stepName="controleren"
    [step]="stepNumber()"
    fieldName="voorwaarden geaccepteerd"
    class="d-block"
    [class.mb-2]="formState().controls.conditionsAccepted | isValid"
    [formsControl]="formState().controls.conditionsAccepted"
  >
    <span wlAutomationId="orderFulfillment-confirm-checkbox-label">{{
      orderContent().acceptConditionsTextBefore
    }}</span>
    @for (disclaimer of disclaimers(); track $index; let i = $index) {
      <span>
        @if (disclaimer.href && disclaimer.key.value) {
          <a
            [href]="disclaimer.href"
            [wlAutomationId]="disclaimer.automationId"
            target="_blank"
            *scText="disclaimer.key"
          ></a>
          @if (i + 1 <= disclaimers().length - 1) {
            <span>, </span>
          }
        }
      </span>
    }
    {{ 'And' | translate }}
    @if (offer(); as offer) {
      <button
        (click)="openAOMModalClick($event)"
        class="tariffs-button btn btn-link p-0"
      >
        {{ 'Tarifs' | translate }}
      </button>
    }
    <span>{{ orderContent().acceptConditionsTextAfter }}</span>
    @if (offer()?.isDynamicProduct) {
      <span>{{ orderContent().acceptConditionsTextDynamicContract }}</span>
    }
  </wl-checkbox>
  @if (formState().controls.conditionsAccepted | isInvalid) {
    <div class="ms-6 mb-2">
      <wl-input-error
        wlAutomationId="conditions-accepted-required-error"
        [messageField]="orderContent().acceptConditionsRequiredError"
        messageDescription="voorwaarden geaccepteerd"
        [rendering]="rendering()"
        stepName="controleren"
        [step]="stepNumber()"
      ></wl-input-error>
    </div>
  }
</ng-template>

<ng-template #atoConsentCard>
  <wl-checkbox
    id="atoConsentBAC"
    [rendering]="rendering()"
    stepName="controleren"
    [step]="stepNumber()"
    fieldName="ato consented"
    class="d-block"
    [formsControl]="formState().controls.atoConsented"
  >
    <span
      wlAutomationId="orderFulfillment-ato-consent-checkbox-label"
      [innerHTML]="orderContent().atoConsentText"
    >
      &nbsp;
    </span>
  </wl-checkbox>
  @if (formState().controls.atoConsented | isInvalid) {
    <div class="ms-6 mb-2">
      <wl-input-error
        wlAutomationId="ato-consent-required-error"
        [messageField]="orderContent().atoConsentRequiredError"
        messageDescription="ato toegestemd"
        [rendering]="rendering()"
        stepName="controleren"
        [step]="stepNumber()"
      ></wl-input-error>
    </div>
  }
</ng-template>
